import copyToClipboard from "copy-to-clipboard";
import { t } from "@/i18n-js/instance";
import { formattedMessageSentAt } from "@circle-react/helpers/dateTimeHelpers/formattedMessageSentAt";
import { dateStringToTimeAgo } from "@circle-react/helpers/dateTimeHelpers/timeAgo";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useToast } from "@circle-react-uikit/ToastV2";
import { getCopyLinkUrl } from "../../helpers";

export interface MessageTimestampProps {
  chatRoomUrl?: string;
  isMessageThread?: boolean;
  isParentMessage?: boolean;
  message: any;
}

export const MessageTimestamp = ({
  message,
  chatRoomUrl = "",
  isParentMessage = false,
  isMessageThread = false,
}: MessageTimestampProps) => {
  const { id, sent_at: sentAt, parent_message_id: parentMessageId } = message;
  const { day, time } = formattedMessageSentAt(sentAt);
  const timeAgo = dateStringToTimeAgo(sentAt);
  const toast = useToast();
  const getMessageTime = () => {
    if (isMessageThread) {
      return isParentMessage ? `${day} at ${time}` : timeAgo;
    }
    return time;
  };

  const isSent = !!id && id > 0;

  const copyLink = () => {
    if (!isSent) {
      return;
    }
    const link = getCopyLinkUrl({
      id,
      parentMessageId,
      chatRoomUrl,
    });
    copyToClipboard(link);
    toast.success(t("messaging.actions.copy_link_success"));
  };

  return (
    <button
      type="button"
      className={classNames(
        "text-timestamp inline min-w-fit text-sm font-medium",
        isSent ? "hover:underline" : "cursor-default",
      )}
      onClick={copyLink}
    >
      {isSent ? getMessageTime() : t("messaging.sending")}
    </button>
  );
};
